"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Textarea = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = require("../../utils/classify");
var _qa = require("../../utils/qa");
var _Text = require("../Text");
var _TextareaModule = _interopRequireDefault(require("./Textarea.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Textarea_ = (props, ref) => {
  const {
    value,
    onChange,
    onFocus,
    onBlur,
    onKeyDown,
    name,
    disabled,
    placeholder,
    error,
    locked,
    errorText,
    label,
    helperText,
    classNames,
    size = 'medium',
    required,
    textCountLimit,
    testId,
    ...textareaProps
  } = props;
  const [textCountError, setTextCountError] = React.useState(false);
  React.useEffect(() => {
    if (textCountLimit) {
      if (value && value.length > textCountLimit) {
        setTextCountError(true);
      } else {
        setTextCountError(false);
      }
    }
  }, [value]);
  const controlledTextareaFilled = value !== '';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'root'
    }),
    className: (0, _classify.classify)(_TextareaModule.default.wrapper, {
      [_TextareaModule.default.filled]: controlledTextareaFilled ?? false,
      [_TextareaModule.default.withError]: (error || textCountError) ?? false
    }),
    children: [Boolean(label) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'label'
      }),
      className: _TextareaModule.default.info,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _TextareaModule.default.infoContent,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.FormLabelSmall, {
          color: "secondary",
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'labelText'
          }),
          children: label ?? ''
        }), "\xA0", required && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.FormLabelSmall, {
          color: "danger",
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'requiredIndicator'
          }),
          children: '*'
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.FormLabelSmall, {
        color: error || textCountError ? 'danger' : 'secondary',
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'textCount'
        }),
        children: !!textCountLimit && (value && value.length || 0) + '/' + textCountLimit
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'box'
      }),
      className: (0, _classify.classify)(_TextareaModule.default.box, {
        [_TextareaModule.default.inputDisabled]: disabled ?? false,
        [_TextareaModule.default.medium]: size === 'medium',
        [_TextareaModule.default.small]: size === 'small',
        [_TextareaModule.default.locked]: locked
      }, classNames?.box),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("textarea", {
        ...textareaProps,
        "data-testid": (0, _qa.generateTestId)({
          base: testId,
          slot: 'textarea'
        }),
        disabled: locked || disabled,
        name: name,
        ref: ref,
        placeholder: placeholder,
        value: value,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        className: classNames?.textarea
      })
    }), (Boolean(helperText) || error) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'helperText'
      }),
      className: _TextareaModule.default.info,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.BodySmall, {
        color: error && errorText ? 'danger' : disabled ? 'disabled' : 'secondary',
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'errorText'
        }),
        children: error && errorText ? errorText : helperText ?? ''
      })
    })]
  });
};
const Textarea = exports.Textarea = /*#__PURE__*/React.forwardRef(Textarea_);